<template>
  <ax-dialog 
    ref="dialog"
    title="Import type curves" 
    icon="mdi-import" 
    tooltip="Import type curves"
    size="medium" 
    :disabled="disabled" 
    @submitted="onSubmit"
    @show="onShow"
  >
    <template slot="content">
      <v-card-text>
        <v-radio-group v-model="selected_type" row>
          <v-radio v-for="(type, index) in types" :label="type.text" :value="type.value" :key="index"></v-radio>
        </v-radio-group>
        <template v-if="selected_type == 'params'">
          <v-text-field type="number" label="Initial production" prefix="qi = " v-model="params.Q" :rules="rules.required"></v-text-field>
          <v-text-field type="number" label="Initial decline" prefix="Di = " v-model="params.D" :rules="rules.required"></v-text-field>
          <v-text-field type="number" label="Hyperbolic exponent" prefix="b = " v-model="params.B" :rules="rules.required"></v-text-field>
        </template>
        <template v-if="selected_type == 'curve'">
          <v-textarea v-model="curve" label="Declined monthly production" hint="Enter as comma-separated list or one month per line" :rules="rules.required"></v-textarea>
        </template>
      </v-card-text>
    </template>
    <template slot="submit_text">Import</template>
  </ax-dialog>
</template>
<script>
import AxDialog from '@/components/dialog'
export default {
  name: "dlgImportTypeCurves",
  props: {
    disabled: { type: Boolean, default: false },
  },
  components: {
    AxDialog
  },
  data() {
    return {
      selected_type: 'params',
      types: [
        { text: 'ARPS parameters', value: "params" },
        { text: 'Declined curve', value: "curve" },
      ],
      params: {
        Q: null,
        D: null,
        B: null
      },
      curve: '',
      rules: {},
    }
  },
  methods: {
    async onShow() {
      this.rules = {}
      await this.$refs.dialog.$refs.form.reset()
      this.selected_type = 'params'
    },
    onSubmit() {
      this.rules = {
        required: [
          v => !!v || 'Required',
          v => !this.isEmpty(v)
        ]
      }
      this.$nextTick(() => {
        //manually trigger Vuetify validation
        if (this.$refs.dialog.$refs.form.validate()) {
          this.$refs.dialog.show = false
          const arr = this.curve.replace(/[ ,\n]+/g, ',').split(',').map(x => parseInt(x))
          this.$emit('submitted', this.selected_type == 'params' ? JSON.parse(JSON.stringify(this.params)) : arr)
        }
      })
    }
  }
}
</script>